import moment from "moment";
import {ATTITUDES, normalizeClubName} from "@/utils/scoutingData";

export const VISIONS_STORAGE_KEY = "scouting_visions_v1";

export const VISION_MODES = [
	{id: "live", label: "Live"},
	{id: "video", label: "Video"},
];

export const VISION_VIEWS = [
	{id: "roster", label: "Rosa"},
	{id: "called", label: "Convocati"},
	{id: "annotated", label: "Annotati"},
];

const ATTITUDE_ORDER = ATTITUDES.map((a) => a.id);

export const isEmptyRow = (row) =>
	!row ||
	(row.starter == null &&
		!(row.attitudes || []).length &&
		!String(row.note || "").trim());

export const updateRow = (rows, playerId, side, patch) => ({
	...rows,
	[playerId]: {
		playerId,
		side,
		starter: null,
		attitudes: [],
		note: "",
		...rows?.[playerId],
		...patch,
	},
});

export const toggleAttitude = (attitudes, id) =>
	(attitudes || []).includes(id)
		? attitudes.filter((a) => a !== id)
		: [...(attitudes || []), id].sort(
				(a, b) => ATTITUDE_ORDER.indexOf(a) - ATTITUDE_ORDER.indexOf(b),
			);

// Visioni di un giocatore dalla più recente, nella forma di GET /Players/{id}/visions.
export const playerVisions = (playerId, all = {}) =>
	Object.values(all)
		.flatMap((byObserver) => Object.values(byObserver || {}))
		.filter((vision) => vision?.rows?.[playerId])
		.map((vision) => {
			const row = vision.rows[playerId];
			return {
				visionId: vision.id || vision.matchId + "_" + vision.observer?.id,
				matchId: vision.matchId,
				matchDate: vision.match?.date || null,
				competition: vision.match?.competition || null,
				homeTeamName: vision.match?.homeTeamName || null,
				awayTeamName: vision.match?.awayTeamName || null,
				observer: vision.observer,
				mode: vision.mode,
				starter: row.starter ?? null,
				attitudes: row.attitudes || [],
				note: row.note || "",
			};
		})
		.sort((a, b) => (b.matchDate || "").localeCompare(a.matchDate || ""));

// Numero di visioni e frequenza delle attitudini per giocatore.
export const visionSummaries = (all = {}) => {
	const summaries = {};
	Object.values(all)
		.flatMap((byObserver) => Object.values(byObserver || {}))
		.forEach((vision) =>
			Object.values(vision?.rows || {}).forEach((row) => {
				const summary = (summaries[row.playerId] ||= {
					count: 0,
					attitudes: {},
				});
				summary.count += 1;
				(row.attitudes || []).forEach(
					(a) => (summary.attitudes[a] = (summary.attitudes[a] || 0) + 1),
				);
			}),
		);
	return summaries;
};

const teamKey = (name) => normalizeClubName(name).toLowerCase();

// Proposta Wyscout: stessa data, entrambe le squadre e una sola corrispondenza; mai un legame ufficiale.
export const exportMatchFor = (vision, matches) => {
	if (!vision?.matchDate || !vision.homeTeamName || !vision.awayTeamName)
		return null;
	const date = moment(vision.matchDate).format("YYYY-MM-DD");
	const home = teamKey(vision.homeTeamName),
		away = teamKey(vision.awayTeamName);
	const candidates = (matches || []).filter(
		(m) =>
			m.date === date && teamKey(m.home) === home && teamKey(m.away) === away,
	);
	return candidates.length === 1 ? {...candidates[0], proposed: true} : null;
};
